/* eslint-disable */
// initial state
// shape: [{ id, quantity }]
const state = {
  myTradeTotal: '0',
  myOrderTotal: '0',
  myHisOrderTotal: '0',
  myTradeRecord: [],
  myTradeRecord1: [],

  myOrderRecord: [],
  myHisOrderRecord: [],
  selAssetDetail: {},
  myAsset: [],
  hazardRate: '0.00', // 风险率合约
  listTotalAssetsMsg: '0.00',// 当前权益
  // commodityStrategy:[],//商品信息
  /* 心跳 */
  newtradeId: null,// 交易表主键
  h_accountTime: null,//资金更新时间 *
  h_deliveryOrderTime: null,//交收订单更新时间 
  h_holdTime: null,//持仓汇总更新时间
  h_orderTime: null,//委托更新时间
  h_outfundTime: null,//出金阈值更新时间 *
  h_sumClosePl: null,//浮动盈亏 *
  h_warehouseTime: null,//交收仓单更新时间
  h_avilibleMargin: null,//可用资金
  h_readFlag: false,//站内信状态
  H_haveAsset: true, // 是否有资金返回 用于风险率提示
  /* 心跳 end */
  systemTime: Number(new Date()),// 系统时间
  marketStatus:{status:''},// status 市场状态 O:开市准备中,T:交易中,P:休市中,R:准备结算中,E:结算中,C:闭市中
  isChangeMarginPsd: true,// 当前用户是否修改过资金密码
  userPositionSummaries: [], // 当前保存的交易页面持仓汇总信息
  
}

// getters
const getters = {
  listTotalAssetsMsgGetter: state => state.listTotalAssetsMsg,
  hazardRateGetter: state => state.hazardRate,
  selAssetDetailGetter: state => state.selAssetDetail,
  myTradeTotalGetter: state => state.myTradeTotal,
  myOrderTotalGetter: state => state.myOrderTotal,
  myHisOrderTotalGetter: state => state.myHisOrderTotal,
  myTradeRecordGetter: (state) => {
    return state.myTradeRecord
  },
  myTradeRecordGetter1: (state) => {
    return state.myTradeRecord1
  },
  myOrderRecordGetter: (state) => {
    return state.myOrderRecord
  },
  myHisOrderRecordGetter: (state) => {
    return state.myHisOrderRecord
  },
  myAssetGetter: state => state.myAsset,
  // commodityStrategyGetter: state => state.commodityStrategy ,
  newtradeIdGetter: state => state.newtradeId,
  h_accountTime: state => state.h_accountTime,
  h_deliveryOrderTime: state => state.h_deliveryOrderTime,
  h_holdTime: state => state.h_holdTime,
  h_orderTime: state => state.h_orderTime,
  h_outfundTime: state => state.h_outfundTime,
  h_sumClosePl: state => state.h_sumClosePl,
  h_warehouseTime: state => state.h_warehouseTime,
  h_readFlag: state => state.h_readFlag,
  marketStatusGetter: state => state.marketStatus,
  h_avilibleMargin: state => state.h_avilibleMargin,
  isChangeMarginPsdGetter: (state) => {
    return state.isChangeMarginPsd
  },
  userPositionSummariesGetter: state => state.userPositionSummaries,
  systemTimeGetter: state => state.systemTime,
  H_haveAsset: state => state.H_haveAsset
}

// actions
const actions = {

}

// mutations
const mutations = {
  setListTotalAssetsMsg(state, data) {
    state.listTotalAssetsMsg = data
  },
  setHazardRate(state, data) {
    state.hazardRate = data
  },
  setMyTradeTotal(state, data) {
    state.myTradeTotal = data
  },
  setMyOrderTotal(state, data) {
    state.myOrderTotal = data
  },
  setMyHisOrderTotal(state, data) {
    state.myHisOrderTotal = data
  },
  setMyTradeRecord(state, data) {
    state.myTradeRecord = data
  },
  setMyTradeRecord1(state, data) {
    state.myTradeRecord1 = data
  },
  setMyOrderRecord(state, data) {
    state.myOrderRecord = data
  },
  setMyHisOrderRecord(state, data) {
    state.myHisOrderRecord = data
  },
  setMyAsset(state, data) {
    state.myAsset = data
  },
  // setCommodityStrategy(state, data) {
  //   state.commodityStrategy = data
  // },
  setNewtradeId(state, data) {
    state.newtradeId = data
  },
  setH_accountTime(state, data){
    state.h_accountTime = data
  },
  setH_deliveryOrderTime(state, data){
    state.h_deliveryOrderTime = data
  },
  setH_readFlag(state, data){
    state.h_readFlag = data
  },
  setH_holdTime(state, data){
    state.h_holdTime = data
  },
  setH_orderTime(state, data){
    state.h_orderTime = data
  },
  setH_outfundTime(state, data){
    state.h_outfundTime = data
  },
  setH_sumClosePl(state, data){
    state.h_sumClosePl = data
  },
  setH_warehouseTime(state, data){
    state.h_warehouseTime = data
  },
  setMarketStatus(state, data){
    state.marketStatus = data
  },
  setH_avilibleMargin(state, data){
    state.h_avilibleMargin = data
  },
  setChangeMarginPsd(state, data) {
    state.isChangeMarginPsd = data
  },
  setNewUserPositionSummaries(state, data) {
    state.userPositionSummaries = data
  },
  setSystemTime(state, data) {
    state.systemTime = data
  },
  setH_haveAsset(state, data) {
    state.H_haveAsset = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
